module.exports = __webpack_public_path__ + "static/media/userCard.17095837.svg";